import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import posed from 'react-pose';
import numeral from 'numeral';

import Button from '../Button';

import styles from './styles.module.css';

const Order = ({products, hostRef}) => (
    <form
        className={styles.container}
        method="get"
        action="https://www.amazon.com/gp/aws/cart/add.html"
        target="_blank"
        ref={hostRef}
    >
        <input type="hidden" name="AWSAccessKeyId" value="AKIAI4XCWNHLF77Z4V5Q" />
        <input type="hidden" name="AssociateTag" value="planetary0c-20" />
        {products.map((product, idx) => (
            <Fragment key={product.asin}>
                <input key={`asin${product.asin}`} type="hidden" name={`ASIN.${idx + 1}`} value={product.asin} />
                <input key={`qty${product.asin}`} type="hidden" name={`Quantity.${idx + 1}`} value={product.amount} />
            </Fragment>
        ))}
        <span className={styles.label}>Total</span>
        <h2 className={styles.total}>
            {numeral(products.reduce(
                (total, product) => total + (product.amount * product.price), 0,
            )).format('$0,0.00')}
        </h2>
        <Button className={styles.buy} type="submit" name="add" value="add">Buy on Amazon</Button>
    </form>
);

Order.propTypes = {
    products: PropTypes.arrayOf(PropTypes.object).isRequired,
    hostRef: PropTypes.func.isRequired,
};

const easeIn = [0.4, 0.0, 1, 1];
const easeOut = [0.0, 0.0, 0.2, 1];

export default posed(Order)({
    preEnter: {
        y: 50,
        opacity: 0,
    },
    enter: {
        y: 0,
        opacity: 1,
        transition: {
            duration: 400,
            ease: easeOut,
        },
    },
    exit: {
        y: 50,
        opacity: 0,
        transition: {
            duration: 400,
            ease: easeIn,
        },
    },
});
